import __vue_normalize__ from '../../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Notification_success_24.vue_rollup-plugin-vue=script.js';

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3 12C3 7.02944 7.02834 3 12 3C16.9706 3 21 7.02834 21 12C21 16.9706 16.9717 21 12 21C7.02944 21 3 16.9717 3 12ZM8.43227 12.5207C8.13663 12.1924 7.48447 12.0283 7.02001 12.4465C6.55554 12.8647 6.65017 13.5304 6.94582 13.8588L8.95293 16.0885C9.27785 16.4493 9.99213 16.4986 10.3652 16.1626L17.0543 10.1413C17.3826 9.84567 17.578 9.2284 17.1284 8.72905C16.6789 8.22969 16.0727 8.33383 15.7444 8.62947L9.77035 14.0072L8.43227 12.5207Z"}})])};
var __vue_staticRenderFns__ = [];

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
